import React, { useState } from "react";
import { useDispatch } from "react-redux";
import Modal, { modalStyles as m } from "./Modal";
import { phpSaveCustomerDetails } from "../data/api";
import { setCustomer } from "../../../Redux/features/WebRegister/cartSlice";
import { ToastifyAlert } from "../../../CommonComponents/ToastifyAlert";
import { validNewCustomer } from "../validators";
import { formatOrderDateTime } from "../engine";

// Create a customer from the register — port of Android's lookup/create dialog
// (InStorePaymentFragment `buttonAddCustomer` → App/save_customer_details).
//
// Android collects only first/last name, phone and email here and sends the rest of the customer
// record blank; the created customer is then attached to the CURRENT cart straight away, which is
// the whole point of creating one mid-sale (loyalty, store credit, and — at a dezi store — the
// customer-specific manufacturer allowances all key off the attached customer).
export default function AddCustomerModal({ initialPhone = "", onCreated, onClose }) {
  const dispatch = useDispatch();
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [phone, setPhone] = useState(initialPhone);
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    const check = validNewCustomer({ firstName, phone, email });
    if (!check.ok) return ToastifyAlert(check.message, "error");
    setBusy(true);
    try {
      const res = await phpSaveCustomerDetails({
        fname: firstName.trim(),
        lname: lastName.trim(),
        email: email.trim(),
        phone_no: String(phone).replace(/\D/g, ""),
        createdDate: formatOrderDateTime(new Date()),
      });
      if (res && (res.status === true || res.status === "true")) {
        const created = {
          customer_id: (res.result && res.result.customer_id) || "",
          fname: firstName.trim(),
          lname: lastName.trim(),
          email: email.trim(),
          phone: String(phone).replace(/\D/g, ""),
          _name: `${firstName.trim()} ${lastName.trim()}`.trim(),
          _phone: String(phone).replace(/\D/g, ""),
        };
        // Attach immediately. A brand-new customer has no loyalty or store-credit balance yet, so
        // those tenders stay unavailable — that matches Android, which attaches the same shape.
        dispatch(setCustomer(created));
        ToastifyAlert("Customer added", "success");
        if (onCreated) onCreated(created);
        onClose();
      } else {
        // Android shows a dedicated message here: the endpoint's usual rejection is a clash on an
        // existing email/phone, not a generic failure.
        ToastifyAlert((res && res.message) || "Customer email id already exists", "error");
      }
    } catch (e) {
      ToastifyAlert("Could not add the customer: " + (e && e.message ? e.message : e), "error");
    } finally {
      setBusy(false);
    }
  };

  return (
    <Modal title="Add customer" onClose={onClose} width={440} zIndex={2100}>
      <div style={m.label}>First name *</div>
      <input autoFocus style={m.input} value={firstName} onChange={(e) => setFirstName(e.target.value)} placeholder="First name" />
      <div style={{ ...m.label, marginTop: 10 }}>Last name</div>
      <input style={m.input} value={lastName} onChange={(e) => setLastName(e.target.value)} placeholder="Last name" />
      <div style={{ ...m.label, marginTop: 10 }}>Mobile number *</div>
      <input
        style={m.input}
        value={phone}
        inputMode="numeric"
        maxLength={10}
        onChange={(e) => setPhone(e.target.value.replace(/\D/g, "").slice(0, 10))}
        placeholder="10-digit mobile"
      />
      <div style={{ ...m.label, marginTop: 10 }}>Email *</div>
      <input style={m.input} value={email} onChange={(e) => setEmail(e.target.value)} placeholder="name@example.com" />
      <button style={{ ...m.primary, opacity: busy ? 0.6 : 1 }} disabled={busy} onClick={submit}>
        {busy ? "Adding…" : "Add customer"}
      </button>
      <button style={m.ghost} onClick={onClose} disabled={busy}>
        Cancel
      </button>
    </Modal>
  );
}
